module.exports = __webpack_public_path__ + "img/jianhao.4703d372.svg";